import React from "react";

//Panels
import { SpeakWithDesigner } from "../../../../CTA/CTA";

//SEO
import SEO from "../../../../SEO/index.js";

const ServiceAreas = () => {
  return (
    <>
      <SEO
        title="Service Area | Southern California | Pacific Pavingstone"
        description="We service the Los Angeles area and are expanding. We have installed tens of thousands of paving stone projects throughout the Southern California area."
        profileURL={"https://www.pacificpavingstone.com/about-us/service-areas"}
        type="website"
      />
      <div className="row justify-content-center panel-content page-service">
        <div className="col-11 col-xl-10">
          <div className="row panel-service-areas">
            <div className="col-lg-6">
              <iframe
                title="Service Areas"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13196.197914722756!2d-118.379461!3d34.221755!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7bf579635b317825!2sPacific%20Pavingstone!5e0!3m2!1sen!2sph!4v1605704410101!5m2!1sen!2sph"
                width="100%"
                height="450"
                frameBorder="0"
                style={{border:0}}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </div>
            <div className="col-lg-4 offset-lg-1">
              <h4 className="mt-5">
                We service the Los Angeles area and are always expanding the areas
                we service. We have installed tens of thousands of paving stone
                projects throughout the Southern California area
              </h4>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <h3 className="text-center text-uppercase">
                Areas we service around Los Angeles
              </h3>
            </div>
            <div className="col-lg-12 no-side-padding">
              <div className="row justify-content-center panel-area-list">
                <div className="col-md-5 col-lg-3">
                  <h4>Agoura Hills</h4>
                  <h4>Alhambra</h4>
                  <h4>Altadena</h4>
                  <h4>Arcadia</h4>
                  <h4>Beverly Hills</h4>
                  <h4>Burbank</h4>
                </div>
                <div className="col-md-5 col-lg-3">
                  <h4>Calabasa</h4>
                  <h4>Encino</h4>
                  <h4>Glendale</h4>
                  <h4>La Canada Flintridge</h4>
                  <h4>La Crescenta</h4>
                  <h4>Los Angeles</h4>
                </div>
                <div className="col-md-5 col-lg-3">
                  <h4>Montrose</h4>
                  <h4>North Hollywood</h4>
                  <h4>Pasadena</h4>
                  <h4>Santa Clarita</h4>
                  <h4>Sherman Oaks</h4>
                  <h4>South Pasadena</h4>
                </div>
                <div className="col-md-5 col-lg-3">
                  <h4>Studio City</h4>
                  <h4>Sun Valley</h4>
                  <h4>Tarzana</h4>
                  <h4>Thousand Oaks</h4>
                  <h4>Valley Village</h4>
                  <h4>Van Nuys</h4>
                  <h4>Weslake Village</h4>
                  <h4>Woodland Hills</h4>
                </div>
              </div>
            </div>
          </div>
          <SpeakWithDesigner />
        </div>
      </div>
    </>
  );
};

export default ServiceAreas;
